import React from 'react'

const CommonLoader = () => {

    return (
        <>
            <div className="centered">
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
        </>
    )
}

export default CommonLoader